<template>
    <div>
        <modal name="modal-edit-add-appareil" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">
                        <template v-if="selectedAppareil.id">Modifier l'appareil</template>
                        <template v-else>Ajouter un appareil</template>
                    </h2>
                    <button @click="$modal.hide('modal-edit-add-appareil');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <template v-if="selectedAppareil.id && selectedAppareil.fournisseur_tel && selectedAppareil.marque == selectedAppareil.fournisseur_tel.marque">
                    <div class="bg-blue-50 p-3 border border-blue-200 rounded-md mb-4">
                        <p class="text-xs font-medium text-blue-900 mb-0.5">Contact fournisseur</p>
                        <p class="text-sm font-semibold text-blue-700"><i class="fas fa-tag mr-1"></i> {{ selectedAppareil.fournisseur_tel.marque }}</p>
                        <p class="text-sm font-semibold text-blue-700"><i class="fas fa-phone mr-1"></i> {{ selectedAppareil.fournisseur_tel.tel }}</p>
                    </div>
                </template>
                <appareil-form v-model="selectedAppareil" />
                <div class="flex justify-center mt-6">
                    <button @click="editAddAppareil" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i class="fas fa-check"></i> Enregistrer l'appareil
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-edit-add-adresse" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">
                        <template v-if="adresseForm.id">Modifier l'adresse</template>
                        <template v-else>Ajouter une adresse</template>
                    </h2>
                    <button @click="$modal.hide('modal-edit-add-adresse');">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <adresse-form v-model="adresseForm" />
                <div class="flex justify-center mt-6">
                    <button :disabled="loadingSaveAdresse" @click="saveAdresse" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i v-if="loadingSaveAdresse" class="fas fa-spinner fa-spin"></i>
                        <span v-else><i class="fas fa-check"></i> Enregistrer l'adresse</span>
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-confirm-delete-client" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Confirmer la suppression du client</h2>
                    <button @click="$modal.hide('modal-confirm-delete-client');"><i class="fas fa-times text-red-500"></i></button>
                </div>
                <p>Êtes-vous sûr de vouloir supprimer cette fiche client ? <br />Cette action est irréversible.</p>
                <div class="flex justify-center mt-6">
                    <button @click="confirmDeleteClient" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <i class="fas fa-check"></i> Confirmer la suppression
                    </button>
                </div>
            </div>
        </modal>

        <app-template>
            <template v-if="loadingGetData">
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm">
                    <div class="flex flex-col items-center justify-center h-96">
                        <i class="fas fa-spinner fa-spin text-4xl text-slate-400 mb-4"></i>
                    </div>
                </div>
            </template>
            <div class="p-6 space-y-8" v-if="!loadingGetData">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <h2 class="text-2xl font-bold text-gray-800"><i class="fas fa-user-circle text-red-600 mr-2"></i> Fiche client</h2>
                        <p class="text-sm text-gray-500 mt-1">Gérez les informations du client et son historique d'intervention.</p>
                    </div>
                    <div class="flex gap-2">
                        <button @click="$router.push({name: 'ClientList'})" class="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-4 py-2 rounded-lg transition flex items-center gap-2">
                            <i class="fas fa-arrow-left"></i> Retour
                        </button>
                        <button @click="$modal.show('modal-confirm-delete-client')" class="bg-red-100 hover:bg-red-200 text-red-700 font-medium px-4 py-2 rounded-lg transition flex items-center gap-2">
                            <i class="fas fa-trash"></i> Supprimer
                        </button>
                    </div>
                </div>

                <div class="bg-white border border-gray-200 rounded-xl shadow-sm">
                    <div class="border-b flex overflow-x-auto">
                        <button
                            v-for="tab in tabs" :key="tab.key"
                            @click="activeTab = tab.key"
                            :class="[
                                'px-6 py-3 text-sm font-medium flex items-center gap-2 transition border-b-2',
                                activeTab === tab.key ? 'text-red-700 border-red-600 bg-red-50' : 'text-gray-600 hover:text-red-700 border-transparent hover:bg-gray-50',
                                tab.key === 'infos' ? 'rounded-tl-xl' : ''
                            ]">
                            <i :class="tab.icon"></i> {{ tab.label }}
                        </button>
                    </div>

                    <div class="p-6 space-y-10">

                        <!-- Informations -->
                        <section v-if="activeTab === 'infos'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800"><i class="fas fa-info-circle text-red-600 mr-2"></i>Informations générales</h3>
                            <client-form v-if="client" v-model="client" />
                            <button :disabled="loadingSaveClient" @click="saveClient" class="mt-8 bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                <template v-if="loadingSaveClient"><i class="fas fa-spinner fa-spin"></i> Enregistrement en cours...</template>
                                <template v-if="!loadingSaveClient"><i class="fas fa-save"></i> Enregistrer</template>
                            </button>
                        </section>

                        <!-- Adresses -->
                        <section v-if="activeTab === 'adresses'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800"><i class="fas fa-map-marker-alt text-red-600 mr-2"></i>Adresses</h3>
                            <template v-if="client && client.adresses && client.adresses.length === 0">
                                <adresse-form v-if="client" v-model="adresseForm" />
                                <button :disabled="loadingSaveAdresse" @click="saveAdresse" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                    <i v-if="loadingSaveAdresse" class="fas fa-spinner fa-spin"></i>
                                    <span v-else><i class="fas fa-check"></i> Enregistrer l'adresse</span>
                                </button>
                            </template>
                            <template v-else>
                                <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                    <table class="w-full text-sm text-left">
                                        <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                            <tr>
                                                <th class="px-6 py-3">Adresse 1</th>
                                                <th class="px-6 py-3">Code postal</th>
                                                <th class="px-6 py-3">Ville</th>
                                                <th class="px-6 py-3">Régie</th>
                                                <th class="px-6 py-3">Locataire</th>
                                                <th class="px-6 py-3">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100">
                                            <tr v-for="item in client.adresses" :key="'adresse-' + item.id" class="hover:bg-red-100 cursor-pointer transition" @click="adresseForm = item; $modal.show('modal-edit-add-adresse')">
                                                <td class="px-6 py-3">{{ item.adresse1 || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.code_postal || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.ville || '-' }}</td>
                                                <td class="px-6 py-3">{{ item.regie ? item.regie.nom : '-' }}</td>
                                                <td class="px-6 py-3">{{ item.locataire ? (item.locataire.prenom ? (item.locataire.nom + ' ' + item.locataire.prenom) : item.locataire.nom) : '-' }}</td>
                                                <td class="px-6 py-3">
                                                    <button class="text-red-600 hover:text-red-800" @click.stop="deleteAdresse(item.id)"><i class="fas fa-trash"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="mt-4">
                                    <button @click="adresseForm = {nom_contact: client.nom, telephone: client.telephone}; $modal.show('modal-edit-add-adresse')" class="bg-red-50 hover:bg-red-100 text-red-700 font-medium px-4 py-2 rounded-lg border border-red-200 transition flex items-center gap-2">
                                        <i class="fas fa-plus"></i> Ajouter une adresse
                                    </button>
                                </div>
                            </template>
                        </section>

                        <!-- Appareils — AppareilsParc en lecture seule -->
                        <section v-if="activeTab === 'appareils'">
                            <appareils-parc
                                v-if="client && client.id"
                                :client-id="client.id"
                                :readonly="true"
                            />
                        </section>

                        <!-- Chantiers -->
                        <section v-if="activeTab === 'chantiers'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800"><i class="fas fa-calendar-check text-red-600 mr-2"></i>Historique des chantiers</h3>
                            <client-chantier-list :client-id="client.id" />
                        </section>

                        <!-- Facturation -->
                        <section v-if="activeTab === 'factures'">
                            <facturation-list-table
                                v-if="client && client.id"
                                :client-id="client.id"
                                :add-button="false"
                            />
                        </section>

                        <!-- Documents -->
                        <section v-if="activeTab === 'documents'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800">
                                <i class="fas fa-folder-open text-red-600 mr-2"></i>
                                Documents
                                <span v-if="documentsPagination.total" class="ml-2 text-sm font-normal text-gray-400">
                                    ({{ documentsPagination.total }})
                                </span>
                            </h3>

                            <!-- Filtres -->
                            <div class="flex flex-wrap gap-3 mb-4">
                                <select
                                    v-model="documentsFilters.appareil_id"
                                    @change="getDocuments(1)"
                                    class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-300"
                                >
                                    <option :value="null">Tous les appareils</option>
                                    <option value="-1">Sans appareil</option>
                                    <option
                                        v-for="appareil in client.appareils"
                                        :key="appareil.id"
                                        :value="appareil.id"
                                    >
                                        {{ appareil.marque }} {{ appareil.modele }} — {{ appareil.numero_serie || 'sans n° série' }}
                                    </option>
                                </select>

                                <select
                                    v-model="documentsFilters.type"
                                    @change="getDocuments(1)"
                                    class="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-300"
                                >
                                    <option :value="null">Tous les types</option>
                                    <option v-for="(label, key) in docType" :key="key" :value="key">
                                        {{ label }}
                                    </option>
                                </select>

                                <button
                                    v-if="documentsFilters.appareil_id || documentsFilters.type"
                                    @click="documentsFilters = { appareil_id: null, type: null }; getDocuments(1)"
                                    class="px-3 py-2 text-sm text-red-600 hover:text-red-800 border border-red-200 rounded-lg hover:bg-red-50 transition flex items-center gap-1"
                                >
                                    <i class="fas fa-times"></i> Réinitialiser
                                </button>
                            </div>

                            <div v-if="loadingDocuments" class="flex items-center justify-center h-40">
                                <i class="fas fa-spinner fa-spin text-3xl text-slate-400"></i>
                            </div>

                            <template v-else>
                                <div v-if="!documents || documents.length === 0" class="text-gray-500 text-sm italic">
                                    Aucun document trouvé pour ce client.
                                </div>
                                <template v-else>
                                    <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                        <table class="w-full text-sm text-left">
                                            <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                                                <tr>
                                                    <th class="px-6 py-3">Type</th>
                                                    <th class="px-6 py-3">Date de création</th>
                                                    <th class="px-6 py-3">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100">
                                                <tr
                                                    v-for="doc in documents"
                                                    :key="'doc-' + doc.id"
                                                    class="hover:bg-red-50 transition"
                                                >
                                                    <td class="px-6 py-3 font-medium text-gray-700">
                                                        <i class="fas fa-file-alt text-red-400 mr-2"></i>
                                                        {{ docType[doc.type] || doc.type }}
                                                    </td>
                                                    <td class="px-6 py-3 text-gray-500">
                                                        {{ doc.created_at | momentDateTime }}
                                                    </td>
                                                    <td class="px-6 py-3">
                                                        <a
                                                            :href="doc.url"
                                                            target="_blank"
                                                            class="inline-flex items-center gap-1 text-red-600 hover:text-red-800 font-medium transition"
                                                        >
                                                            <i class="fas fa-external-link-alt"></i> Ouvrir
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Pagination -->
                                    <div v-if="documentsPagination.last_page > 1" class="flex items-center justify-between mt-4">
                                        <p class="text-sm text-gray-500">
                                            Page {{ documentsPagination.current_page }} sur {{ documentsPagination.last_page }}
                                        </p>
                                        <div class="flex items-center gap-1">
                                            <button
                                                @click="getDocuments(1)"
                                                :disabled="documentsPagination.current_page === 1"
                                                class="px-2 py-1.5 rounded text-sm border transition"
                                                :class="documentsPagination.current_page === 1 ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-100'"
                                            >
                                                <i class="fas fa-angle-double-left"></i>
                                            </button>
                                            <button
                                                @click="getDocuments(documentsPagination.current_page - 1)"
                                                :disabled="documentsPagination.current_page === 1"
                                                class="px-2 py-1.5 rounded text-sm border transition"
                                                :class="documentsPagination.current_page === 1 ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-100'"
                                            >
                                                <i class="fas fa-angle-left"></i>
                                            </button>

                                            <template v-for="page in documentsPagination.last_page">
                                                <button
                                                    v-if="page >= documentsPagination.current_page - 2 && page <= documentsPagination.current_page + 2"
                                                    :key="'page-' + page"
                                                    @click="getDocuments(page)"
                                                    class="px-3 py-1.5 rounded text-sm border transition"
                                                    :class="page === documentsPagination.current_page ? 'bg-red-600 text-white border-red-600 font-semibold' : 'text-gray-600 border-gray-300 hover:bg-gray-100'"
                                                >
                                                    {{ page }}
                                                </button>
                                            </template>

                                            <button
                                                @click="getDocuments(documentsPagination.current_page + 1)"
                                                :disabled="documentsPagination.current_page === documentsPagination.last_page"
                                                class="px-2 py-1.5 rounded text-sm border transition"
                                                :class="documentsPagination.current_page === documentsPagination.last_page ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-100'"
                                            >
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                            <button
                                                @click="getDocuments(documentsPagination.last_page)"
                                                :disabled="documentsPagination.current_page === documentsPagination.last_page"
                                                class="px-2 py-1.5 rounded text-sm border transition"
                                                :class="documentsPagination.current_page === documentsPagination.last_page ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-100'"
                                            >
                                                <i class="fas fa-angle-double-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </section>

                        <!-- Notes -->
                        <section v-if="activeTab === 'notes'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800"><i class="fas fa-file-alt text-red-600 mr-2"></i>Notes et documents</h3>
                            <client-notes-view :client-id="client.id" />
                        </section>

                        <!-- Portail -->
                        <section v-if="activeTab === 'portail'">
                            <h3 class="text-lg font-semibold mb-4 text-gray-800"><i class="fas fa-globe text-red-600 mr-2"></i>Portail client</h3>
                            <div class="grid grid-cols-2 gap-4">
                                <div class="bg-gradient-to-br from-red-50 to-orange-50 border border-red-200 rounded-xl p-6 shadow-sm">
                                    <div class="flex-1">
                                        <h4 class="text-lg font-semibold text-gray-800 mb-2">Accès au portail client</h4>
                                        <p class="text-sm text-gray-600 mb-4">Votre client peut consulter ses interventions, factures et documents via son portail personnalisé.</p>
                                        <a :href="`/c/${client.token}`" target="_blank" class="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition">
                                            <i class="fas fa-external-link-alt"></i> Ouvrir le portail du client
                                        </a>
                                    </div>
                                </div>
                                <div class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                                    <h4 class="text-lg font-semibold text-gray-800 mb-2">Envoyer le lien par email</h4>
                                    <p class="text-sm text-gray-600 mb-4">Envoyez un email contenant le lien d'accès au portail client.</p>
                                    <button :disabled="loadingSendPortalMail" @click="sendPortailMail" class="inline-flex items-center gap-2 bg-red-50 hover:bg-red-100 text-red-700 font-medium px-4 py-2 rounded-lg border border-red-200 transition">
                                        <template v-if="loadingSendPortalMail"><i class="fas fa-spinner fa-spin"></i> Envoi en cours...</template>
                                        <template v-if="!loadingSendPortalMail"><i class="fas fa-envelope"></i> Envoyer l'email</template>
                                    </button>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </app-template>
    </div>
</template>

<script>
import moment from 'moment'
import DocType from './../../config/docType.js'

import ClientForm         from './Components/ClientForm.vue'
import AppareilForm       from './Components/AppareilForm.vue'
import AdresseForm        from './Components/AdresseForm.vue'
import ClientFactureList  from './Components/ClientFactureList.vue'
import ClientChantierList from './Components/ClientChantierList.vue'
import ClientNotesView    from './Components/ClientNotesView.vue'
import AppareilsParc      from './Components/AppareilsParc.vue'
import FacturationListTable from './../Facturation/FacturationListTable.vue'

export default {
    name: 'ClientView',
    components: {
        ClientForm, AppareilForm, AdresseForm,
        ClientFactureList, ClientChantierList, ClientNotesView,
        AppareilsParc, FacturationListTable,
    },
    watch: {
        activeTab(val) {
            if (val === 'documents') {
                this.documentsPagination.current_page = 1
                this.documentsFilters = { appareil_id: null, type: null }
                this.getDocuments(1)
            }
        }
    },
    data() {
        return {
            client: { nom: '', prenom: '', email: '', telephone: '', adresse1: '', adresse2: '', ville: '', code_postal: '', pays: '', type_client: '', siret: '' },
            activeTab: 'infos',
            tabs: [
                { key: 'infos',     label: 'Général',     icon: 'fas fa-id-card' },
                { key: 'adresses',  label: 'Adresses',    icon: 'fas fa-map-marker-alt' },
                { key: 'appareils', label: 'Appareils',   icon: 'fas fa-toolbox' },
                { key: 'chantiers', label: 'Chantiers',   icon: 'fas fa-helmet-safety' },
                { key: 'documents', label: 'Documents', icon: 'fas fa-folder-open' },
                { key: 'factures',  label: 'Facturation', icon: 'fas fa-file-invoice' },
                { key: 'notes',     label: 'Notes',       icon: 'fas fa-file-alt' },
            ],
            adresseForm: {},
            selectedAppareil: {},
            documents: [],
            loadingDocuments: false,
            documentsPagination: {
                current_page: 1,
                last_page: 1,
                total: 0,
                per_page: 15,
            },
            docType: DocType,
            documentsFilters: {
                appareil_id: null,
                type: null,
            },
            loadingSaveClient: false,
            loadingGetData: false,
            loadingSaveAdresse: false,
            loadingSendPortalMail: false,
        }
    },
    filters: {
        momentDate(date) { return date ? moment(date).format('DD/MM/YYYY') : '-' },
        momentDateTime(date) { return date ? moment(date).format('DD/MM/YYYY HH:mm') : '-' },
    },
    methods: {
        async getClient() {
            const id = this.$route.params.id
            try {
                this.loadingGetData = true
                this.client = await this.$request.get(`/clients/${id}`)
                if (this.client.adresses && this.client.adresses.length <= 0) {
                    this.adresseForm = { nom_contact: this.client.nom, telephone: this.client.telephone }
                }
            } catch (e) {
                this.$toast.error('Impossible de charger le client.')
            } finally {
                this.loadingGetData = false
            }
        },

        async saveClient() {
            const id   = this.$route.params.id
            const type = this.client.type_client || 'particulier'
            const rules = type === 'professionnel'
                ? ['proprietaire-nom:required|min=2', 'proprietaire-siret:required|siret']
                : ['proprietaire-nom:required|min=2', 'proprietaire-email:required|email', 'proprietaire-telephone:required|tel']
            if (!this.$inpError(rules)) { this.$toast.error('Formulaire invalide'); return }
            try {
                this.loadingSaveClient = true
                await this.$request.post(`/clients/${id}`, this.client)
                this.$toast.success('Client mis à jour')
            } catch (e) {
                this.$toast.error('Erreur lors de la mise à jour du client')
            } finally {
                this.loadingSaveClient = false
            }
        },

        async editAddAppareil() {
            const validation = this.$inpError(['inp-type:required|min=3', 'inp-marque:required|min=2', 'inp-modele:required|min=2', 'inp-numero_serie:nullable|min=3'])
            if (!validation) { this.$toast.error('Formulaire invalide'); return }
            try {
                const url = this.selectedAppareil.id ? `/client-appareils/${this.selectedAppareil.id}` : '/client-appareils'
                this.selectedAppareil.client_id = this.client.id
                await this.$request.post(url, this.selectedAppareil)
                await this.getClient()
                this.$toast.success('Appareil ajouté')
                this.$modal.hide('modal-edit-add-appareil')
                this.selectedAppareil = {}
            } catch (e) {
                this.$toast.error("Erreur lors de l'enregistrement de l'appareil")
            }
        },

        async confirmDeleteClient() {
            const id = this.$route.params.id
            const response = await this.$request.post(`/clients/${id}/delete`)
            if (response) { this.$toast.success('Client supprimé'); this.$router.push({ name: 'ClientList' }) }
            else { this.$toast.error('Erreur lors de la suppression du client') }
        },

        async saveAdresse() {
            this.loadingSaveAdresse = true
            try {
                const { regie, locataire, ...adressePayload } = this.adresseForm
                const hasRegie     = !!(regie && regie.nom)
                const hasLocataire = !!(locataire && (locataire.nom || locataire.prenom || locataire.email || locataire.telephone))
                const proprietaireType = this.client.type_client || 'particulier'
                const regieType        = regie?.type_client || 'particulier'
                const locataireType    = locataire?.type_client || 'particulier'
                const rules = []

                if (hasRegie) { rules.push('proprietaire-nom:required|min=2') }
                else if (proprietaireType === 'professionnel') { rules.push('proprietaire-nom:required|min=2', 'proprietaire-siret:required|siret') }
                else { rules.push('proprietaire-nom:required|min=2', 'proprietaire-email:required|email', 'proprietaire-telephone:required|tel') }

                if (hasRegie) {
                    if (regieType === 'professionnel') { rules.push('regie-nom:required|min=2', 'regie-siret:required|siret') }
                    else { rules.push('regie-nom:required|min=2', 'regie-email:required|email', 'regie-telephone:required|tel') }
                }
                if (hasLocataire && locataireType === 'professionnel') { rules.push('locataire-nom:required|min=2', 'locataire-siret:required|siret') }
                if (!this.$inpError(rules)) { this.$toast.error('Formulaire invalide'); this.loadingSaveAdresse = false; return }
                if (locataire && !hasLocataire) { this.$toast.error('Veuillez remplir au moins un champ pour le locataire'); this.loadingSaveAdresse = false; return }

                let regieId = adressePayload.regie_id || 0
                let locataireId = adressePayload.locataire_id || 0

                if (regie?.nom && !regie.id) {
                    const res = await this.$request.post('/clients', { ...regie, type: 'regie', regie_id: 0, proprietaire_id: 0 })
                    regieId = res.client.id
                } else if (regie?.id) { await this.$request.post(`/clients/${regie.id}`, regie); regieId = regie.id }

                if (locataire?.nom && !locataire.id) {
                    const res = await this.$request.post('/clients', { ...locataire, type: 'locataire', regie_id: regieId, proprietaire_id: this.$route.params.id })
                    locataireId = res.client.id
                } else if (locataire?.id) { await this.$request.post(`/clients/${locataire.id}`, locataire); locataireId = locataire.id }

                const url = adressePayload.id ? `/client-adresses/${adressePayload.id}` : `/clients/${this.$route.params.id}/adresses`
                await this.$request.post(url, { ...adressePayload, client_id: this.$route.params.id, regie_id: regieId, locataire_id: locataireId })
                this.adresseForm = {}
                await this.getClient()
                this.$modal.hide('modal-edit-add-adresse')
            } catch (e) {
                console.error(e)
                this.$toast.error("Erreur lors de l'enregistrement de l'adresse")
            } finally {
                this.loadingSaveAdresse = false
            }
        },

        async deleteAdresse(adresseId) {
            if (confirm('Êtes-vous sûr de vouloir supprimer cette adresse ?')) {
                try {
                    await this.$request.post(`/client-adresses/${adresseId}/delete`)
                    this.$toast.success('Adresse supprimée')
                    await this.getClient()
                } catch (e) {
                    this.$toast.error("Erreur lors de la suppression de l'adresse")
                }
            }
        },

        async sendPortailMail() {
            try {
                this.loadingSendPortalMail = true
                await this.$request.post('/clients/send-portail-mail', { client_id: this.client.id })
                this.$toast.success('Email envoyé au client')
            } catch (e) {
                this.$toast.error("Erreur lors de l'envoi de l'email")
            } finally {
                this.loadingSendPortalMail = false
            }
        },
        async getDocuments(page = 1) {
            const id = this.$route.params.id
            try {
                this.loadingDocuments = true
                const response = await this.$request.post(`/clients/get-documents`, {
                    client_id: id,
                    page: page,
                    appareil_id: this.documentsFilters.appareil_id || null,
                    type: this.documentsFilters.type || null,
                })
                this.documents = response.data
                this.documentsPagination = {
                    current_page: response.current_page,
                    last_page:    response.last_page,
                    total:        response.total,
                    per_page:     response.per_page,
                }
            } catch (e) {
                this.$toast.error('Impossible de charger les documents.')
            } finally {
                this.loadingDocuments = false
            }
        },
    },
    async mounted() {
        this.getClient()
        if (this.$account.account.societe.has_portail) {
            this.tabs.push({ key: 'portail', label: 'Portail client', icon: 'fas fa-globe' })
        }
    },
}
</script>